// frontend/src/components/CardAlertMeasures.js
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ChecklistRounded from '@mui/icons-material/ChecklistRounded';
import Skeleton from '@mui/material/Skeleton';

export default function CardAlertMeasures({ content, loading }) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <ChecklistRounded fontSize="small" sx={{ mr: 1, color: 'success.main' }} />
          <Typography sx={{ fontWeight: 600 }}>
            Recommended Measures
          </Typography>
        </Box>
         {loading ? (
          <>
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} />
          </>
        ) : (
          <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
            {content || 'Follow standard emergency procedures.'}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}